// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import BellTwoToneSvg from "@ant-design/icons-svg/es/asn/BellTwoTone";
import AntdIcon from '../components/AntdIcon';

var BellTwoTone = function BellTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: BellTwoToneSvg
  }));
};

BellTwoTone.displayName = 'BellTwoTone';
export default React.forwardRef(BellTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/BellTwoTone.js
// module id = 641
// module chunks = 0